import serviceClient from '../../service-client/service-client';
import actionTypes from '../constants/action-types';
import DEFAULT_THUMBNAIL_SIZE from '../constants/default-thumbnail-size';

const assetsUploader = () => (next) => (action) => {
  switch (action.type) {
    case actionTypes.CREATE_MEDIA_GALLERY_ASSETS: {
      const { data, config, resolve, reject } = action.payload;

      serviceClient
        .get()
        .createMediaLibraryAssets(data, {
          thumbnailSize: DEFAULT_THUMBNAIL_SIZE,
          ...config,
        })

        .then((result) => {
          resolve(result);
          next(action);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
          next(action);
        });
      break;
    }

    default:
      next(action);
  }
};

export default assetsUploader;
